import { Component, OnInit, Inject, ViewChild, TemplateRef, Output, EventEmitter, Input } from '@angular/core';
import AccessControlListComponentView from './access-control-list.component.html';
import { LogService } from '../../../../core/services/log.service';
import { EventGuest } from '../../../../shared/models/events/guests/event-guest.model';
import { GuestAccessStatusPipe } from '../../pipes/guest-access-status.pipe';
import { GuestAccessStatusColorPipe } from '../../pipes/guest-access-status-color.pipe';
import { Table } from 'primeng/table';
import { GridConfig } from '../../../../shared/components/grid/models/grid-config.model';
import { EventGuestsService } from '../../services/event-guests.service';
import { SortEvent } from 'primeng/api';
import moment from 'moment';
import { EventsService } from '../../services/events.service';
import { forEach } from 'lodash';

interface GuestAccessStatus {
  id: number;
  name: string;
  color: string;
}

interface GuestAccessResumeeData {
    statusId: number;
    guestCount: number;
}

@Component({
  selector: 'access-control-list',
  template: AccessControlListComponentView
})
export class AccessControlListComponent implements OnInit {  
  @ViewChild('guestFullnameTemplate') private guestFullnameTemplate: TemplateRef<object>;
  @ViewChild('guestAccessStatusTemplate') private guestAccessStatusTemplate: TemplateRef<object>;
  @Input('timezone') private timezone: string = 'Europe/Madrid';
  @Input() set dateSelected(date: string) {
    this._dateSelected = date;
    this.filterGuests();
  }
  get dateSelected(): string {
    return this._dateSelected;
  }

  statuses: GuestAccessStatus[] = [];

  gridConfig: GridConfig = {
    columns: []
  };
  
  searchValue: string = '';
  filteredGuests: EventGuest[] = [];

  private eventId: number;
  private _dateSelected: string;
  private guests: EventGuest[];
  private hourOffset: number;
  private localHourOffset: number;
  private accessResumee: Array<GuestAccessResumeeData> = [
        { statusId: 0, guestCount: 0 },
        { statusId: 1, guestCount: 0 },
        { statusId: 2, guestCount: 0 }
  ];


  constructor(@Inject(LogService) private log: LogService,
              @Inject(GuestAccessStatusPipe) private guestAccessStatusPipe: GuestAccessStatusPipe,
              @Inject(GuestAccessStatusColorPipe) private guestAccessStatusColorPipe: GuestAccessStatusColorPipe,
              @Inject(EventGuestsService) private eventGuestsService: EventGuestsService,
              @Inject('$stateParams') private $stateParams: any) { 
      this.eventId = this.$stateParams.id;
  }

  ngOnInit() {

        this.eventGuestsService.accesses$.subscribe(guests => {

            this.guests = guests.filter(g => g.access_status >= 0);

            this.filterGuests();

            this.updateAccessResumee();

        });

       this.eventGuestsService.getAccesses(this.eventId);

       let timezoneOffset = moment.tz(this.timezone).format('Z');
       this.hourOffset = parseInt(timezoneOffset.split(":")[0], 10)

       let localTimezoneOffset = moment.tz(moment.tz.guess()).format('Z');
       this.localHourOffset = parseInt(localTimezoneOffset.split(":")[0], 10);

  }   

  ngAfterViewInit() {
    Array.from([0, 1, 2]).forEach(status => {
      this.statuses.push({
        id: status,
        name: this.guestAccessStatusPipe.transform(status),
        color: this.guestAccessStatusColorPipe.transform(status)
      });
    });

  this.gridConfig = {
      timezone: this.timezone,
      panelTitle: 'dashboard.more_details',
      columns : [
      {
        name: 'name',
        header: { displayName:  'events.guests.name' },
        template: this.guestFullnameTemplate,
        enableSorting: true,
      },
      {
        name: 'check_in_date',
        header: { displayName: 'general.date', style: 'width: 150px; text-align: center;' },
        type: 'datetimetz',
        enableSorting: true
      },
      {
        name: 'access_status',
        header: { displayName: 'events.guests.status', style: 'width: 150px; text-align: center;' },
        template: this.guestAccessStatusTemplate,
        filter: {
          type: 'valueList',
          values: this.statuses,
          placeholder: 'events.guests.status'
        }
      }

    ],
    actions: [
      {
        label: 'events.resume.confirm_assistance',
        icon: 'pi pi-check',
        command: (row) => this.modifyStatus(row, 'ConfirmAssistance'),
        showCondition: (row) => row.access_status === 0
      },
      {
        label: 'events.resume.delete_assistance',
        icon: 'pi pi-times',
        severity: 'danger',
        command: (row) => this.modifyStatus(row, 'DeleteAssistance'),
        showCondition: (row) => row.access_status !== 0
      }
    ],
    globalFilterFields: ['name', 'surname', 'lastname', 'position', 'position_group_name'],
    resizableColumns: true,
    sortMode: 'single',
    stateStorage: 'local',
    stateKey: 'guestAccessTable',
    enableSelection: false,
    sortField: 'check_in_date',
    sortOrder: -1,
    dataKey: 'id',
    customSortFunction: (event: SortEvent) => {
      if(event.field !== undefined) {
        if(event.order === undefined) {
          event.order = 1;
        }
        return event.data!.sort((a, b) => {
          if(event.field === 'check_in_date') {
            let aDate = a.check_in_date ? new Date(a.check_in_date) : new Date(0);
            let bDate = b.check_in_date ? new Date(b.check_in_date) : new Date(0);
            return event.order! * ((aDate < bDate) ? -1 : (aDate > bDate) ? 1 : 0);
          } else if(event.field === 'name') {
            const aName = (a.surname + ' ' + a.lastname + ' ' + a.name).toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            const bName = (b.surname + ' ' + b.lastname + ' ' + b.name).toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            return event.order! * ((aName < bName) ? -1 : (aName > bName) ? 1 : 0);
          }
          return event.order! * ((a < b) ? -1 : (a > b) ? 1 : 0);
        });
      }

       return event!.data;

    },
    customSort: true,
    showColumnSelector: false,
    showClearButton: false,
    showExportButton: true,
    exportType: 'event_resume',

    exportOptions: {
        filters: {
        LOCAL_HOUR_OFFSET: this.localHourOffset,
        EVENT_HOUR_OFFSET: this.hourOffset,
        EVENT_ID: this.eventId,
        EXPORT_TYPE: "RESUME",
    }

    },
    showRefreshButton: true,
    refreshCallback: () => {
        this.eventGuestsService.getAccesses(this.eventId);
    }
  };
}

  modifyStatus(guest: EventGuest, status: string) {

    if(status === 'ConfirmAssistance') {
      this.eventGuestsService.checkIn(guest);
    } else {
      this.eventGuestsService.deleteCheckIn(guest);
    }

    this.log.debug('status changed to ' + status, { 'guestId': guest.id });

  }

  clear(table: Table) {
    table.clear();
    this.searchValue = '';
    table.filters = {}
  }

  removeDateSelected(event: any) {
    this.dateSelected = '';
  }

  private filterGuests() {

    if (this.dateSelected) {

      this.filteredGuests = this.guests.filter(g => g.FK_events_guests_check_in_events_guests.some(c => new Date(c.check_in_day).toLocaleDateString('es-ES') === this.dateSelected));

      // Modify check_in_date to the found check_in_day
      this.filteredGuests.forEach(g => {

            const checkIn = g.FK_events_guests_check_in_events_guests.find(c => new Date(c.check_in_day).toLocaleDateString('es-ES') === this.dateSelected);

            if (checkIn) {
                g.check_in_date = checkIn.check_in_day;
            }

      });

      // Add all non existent guests to the filteredGuests as access_status 0
      this.guests.forEach(g => {
        if (!this.filteredGuests.some(fg => fg.id === g.id)) {

              this.filteredGuests.push({ ...g, access_status: 0, check_in_date: null });

        }
      });

    } else {

        this.filteredGuests = this.guests;

    }

  }

  private updateAccessResumee() {

      let accessResumee = [
          { statusId: 0, guestCount: 0 },
          { statusId: 1, guestCount: 0 },
          { statusId: 2, guestCount: 0 }
      ];

      this.guests.forEach(function (g) {
          accessResumee[g.access_status].guestCount++;
      });

      this.accessResumee = accessResumee;

  }

}
